/** The session composer's model chip + picker: applies a signed `run.set_model`. */
import { type Agent, type CliModel, ModelPicker } from '@viko/transcript-ui'
import { useBackend } from '../lib/backend.js'
import { errorText, useToast } from './ui.js'

const ENDED = new Set(['done', 'stopped', 'failed', 'cancelled'])

/** Why the model can't be switched right now, if it can't. */
export function modelSwitchBlock(o: {
  machineId?: string | undefined
  machineOnline?: boolean | undefined
  status?: string | undefined
}): string | undefined {
  if (!o.machineId) return 'This run has no machine yet.'
  if (o.machineOnline === false) return 'This run’s machine is offline.'
  if (o.status && ENDED.has(o.status))
    return 'This run has ended; start a new session to change model.'
  return undefined
}

export function ModelControl({
  runId,
  machineId,
  agent,
  model,
  effort,
  disabledReason,
  cliModels,
}: {
  runId: string
  machineId: string
  agent: Agent
  model: string
  effort?: string | undefined
  disabledReason?: string | undefined
  /** The CLI's reported models (run.start); the built-in list when absent. */
  cliModels?: readonly CliModel[] | undefined
}) {
  const b = useBackend()
  const toast = useToast()
  return (
    <ModelPicker
      agent={agent}
      model={model}
      {...(effort ? { effort } : {})}
      {...(disabledReason ? { disabledReason } : {})}
      {...(cliModels?.length ? { cliModels } : {})}
      onApply={(m, e) =>
        b.dispatch('run.set_model', machineId, { runId, model: m, ...(e ? { effort: e } : {}) })
      }
      onError={(e) => toast(errorText(e), 'error')}
    />
  )
}
